export default __webpack_public_path__ + "static/media/O-020.318609d6.png";